module.exports = __webpack_public_path__ + "static/media/FIPE_2_LIVELLO1.c40b9bf8.jpg";